<template>
    <Vuetable
        :fields="fields"
        :api-mode="false"
        :data="documents"
    >

    </Vuetable>
</template>

<script>
import Vuetable from 'vuetable-2/src/components/Vuetable';
import Vue from 'vue';
import ColumnSector from '@components/Documents/Conferences/Columns/ColumnSector.vue';
import ColumnWebsite from '@components/Documents/Conferences/Columns/ColumnWebsite.vue';
Vue.component('column-sector', ColumnSector);
Vue.component('column-website', ColumnWebsite)

export default {
    name: "ListGenericDocuments",
    components: {
        Vuetable
    },
    props: {
        documents: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            fields: [
                {
                    name: 'client',
                    sortField: 'client',
                    title: 'Client',
                    width: '150px',
                    dataClass: 'data-label data-client'
                },
                {
                    name: 'deal_type',
                    sortField: 'deal_type',
                    title: 'Deal Type',
                    width: '130px',
                    dataClass: 'data-label deal-type'
                },
                {
                    name: '__component:column-website',
                    sortField: "website",
                    title: "Website",
                    width: '100px',
                    dataClass: "data-label data-website"
                },
                {
                    name: '__component:column-sector',
                    title: 'Sector',
                    width: '200px',
                    dataClass: 'data-sector'
                },
                {
                    name: "comments",
                    title: "Comments",
                    width: "200px",
                    dataClass: "data-label data-comments"
                },
                {
                    name: "financials",
                    title: "Financials",
                    width: "100px",
                    dataClass: "data-label data-financials"
                },
                {
                    name: "ma_contact",
                    title: "MA contact",
                    width: "100px",
                    dataClass: "data-label data-contact"
                },
                {
                    name: "has_description",
                    title: "Description",
                    width: "100px",
                    dataClass: "data-label data-background"
                },
                {
                    name: "has_context",
                    title: "Background",
                    width: "100px",
                    dataClass: "data-label data-context"
                },
            ]
        }
    }
}
</script>

<style scoped lang="scss">

</style>
